function generateMeter(companyMeter) {
  const max = companyMeter.data('max');
  const value = companyMeter.data('value');

  if (max === 0) {
    companyMeter.progressbar({ value: 0 });
    companyMeter.find('.ui-progressbar-value').addClass('tw-block tw-w-0.5');
    return;
  }

  companyMeter.progressbar({ max, value });
}
export { generateMeter };
